import React, { useState } from "react";
import { surfaces } from "../../styles/index";

export default function HoverCard({ children, onClick, style }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      role="button"
      onMouseDown={(e) => e.preventDefault()} // prevent focus ring
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...surfaces.card,
        cursor: "pointer",
        boxShadow: hovered
          ? "0 12px 28px rgba(0,0,0,0.12)"
          : surfaces.card.boxShadow,
        transition: "box-shadow 0.15s ease",
        maxWidth: 420,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
